const redirectTo = path => {
  window.location.href = path
}

export default { redirectTo }
